var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKardiologie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.945 50.691C9.84 70.764 25.549 92.845 52.212 92.845c29.058 0 42.216-24.95 39.53-46.028-2.687-21.068-17.029-35.11-39.768-35.11-28.337.004-40.134 22.701-41.03 38.984z",
    stroke: "#6EC2DE",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.514 50.95c-.925 16.824 12.238 35.318 34.577 35.318 24.35 0 35.373-20.906 33.123-38.563-2.253-17.658-14.27-29.42-33.32-29.42-23.742.003-33.627 19.018-34.38 32.665z",
    stroke: "#6EC2DE",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.177 64.612a5.733 5.733 0 005.844 5.973c4.111 0 5.977-3.536 5.594-6.514-.379-2.987-2.407-4.97-5.627-4.97-4.016-.004-5.686 3.208-5.811 5.511zM41.051 45.78c3.72.204 7.806-2.699 7.806-7.643 0-5.382-4.62-7.819-8.522-7.323-3.903.5-6.502 3.157-6.502 7.368 0 5.249 4.202 7.432 7.218 7.598z",
    stroke: "#6EC2DE",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.741 52.79c-.03.509.441 1.067 1.196 1.067.82 0 1.195-.629 1.12-1.166-.08-.534-.504-.963-1.12-.913-.88.08-1.171.6-1.196 1.013zM24.092 49.25c-.03.508.441 1.066 1.195 1.066.82 0 1.196-.629 1.12-1.162-.079-.537-.503-.966-1.12-.916-.883.075-1.17.595-1.195 1.012z",
    stroke: "#6EC2DE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.237 37.578c-4.466 2.208-2.391 1.28-4.54 2.537-1.496.875-3.812 3.437-1.983 6.694 1.562 2.79 4.46 2.645 7.447 1.108a321.748 321.748 0 017.12-3.549s4.548-1.987 2.232-6.735c-1.458-2.991-5.011-2.604-6.698-1.88-1.683.73-1.57.83-3.578 1.825z",
    stroke: "#6EC2DE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.283 68.582c-3.057-3.353-1.72-1.775-3.361-3.341-1.142-1.087-3.962-2.47-6.357-.054-2.045 2.066-1.191 4.57.904 6.794a311.281 311.281 0 014.89 5.336s2.875 3.486 6.453.262c2.249-2.02 1.016-5.036-.042-6.327-1.05-1.287-1.112-1.162-2.487-2.67z",
    stroke: "#90DCF5",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.112 34.675s1.416-3.066 2.362-4.957c.945-1.887 2.124-4.011 2.124-4.011M28.34 62.325s2.892-1.753 4.733-2.79c1.837-1.038 4.007-2.146 4.007-2.146",
    stroke: "#90DCF5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
export default SvgKardiologie;